// Single minimum HTTP fallback cadence for SSE-backed UI surfaces.
// SSE retry timers and local animation/countdown timers are intentionally separate.
export const SSE_HTTP_FALLBACK_INTERVAL_MS = 60_000;

export function sseHttpFallbackDelay(serverSuggestedMs) {
  const suggested = Number(serverSuggestedMs);
  return Number.isFinite(suggested) && suggested > SSE_HTTP_FALLBACK_INTERVAL_MS
    ? suggested : SSE_HTTP_FALLBACK_INTERVAL_MS;
}
